var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M241.154+789.224L96.3106+789.224C73.4461+789.224+54.9269+771.044+54.9269+748.598L54.4707+409.766C54.4707+358.76+124.911+342.907+124.911+342.907C124.911+342.907+852.654+341.929+890.674+341.929C928.694+341.929+965.368+362.661+965.368+402.362L965.368+748.598C965.368+771.044+946.849+789.224+923.984+789.224L767.156+789.224",
    opacity: 1,
    fill: "#81d7c8"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1,
    opacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    d: "M891.474+386.362L894.87+386.362C902.217+386.362+908.172+393.078+908.172+401.362L908.172+401.362C908.172+409.646+902.217+416.362+894.87+416.362L891.474+416.362C884.128+416.362+878.172+409.646+878.172+401.362L878.172+401.362C878.172+393.078+884.128+386.362+891.474+386.362Z",
    fill: "#f3fa59"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeLinejoin: "round",
    opacity: 1,
    d: "M890.976+436.671L894.372+436.671C901.719+436.671+907.674+443.387+907.674+451.671L907.674+451.671C907.674+459.956+901.719+466.671+894.372+466.671L890.976+466.671C883.63+466.671+877.674+459.956+877.674+451.671L877.674+451.671C877.674+443.387+883.63+436.671+890.976+436.671Z",
    stroke: "#000000",
    fill: "#b3fff2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeWidth: 1,
    fill: "#b3fff2",
    d: "M891.972+482L895.369+482C902.715+482+908.67+488.716+908.67+497L908.67+497C908.67+505.284+902.715+512+895.369+512L891.972+512C884.626+512+878.67+505.284+878.67+497L878.67+497C878.67+488.716+884.626+482+891.972+482Z",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1,
    fill: "#f3f3f3",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    opacity: 1,
    d: "M767.156+341.718L767.156+196.556L237.585+196.556L237.585+341.718M767.156+599.777L767.156+913.554L237.585+913.554L237.585+599.777L767.156+599.777Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.373+843.078L318.242+843.078L318.242+864.093L300.373+864.093L300.373+843.078Z",
    opacity: 1,
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#555555",
    d: "M300.373+790.541L318.242+790.541L318.242+811.556L300.373+811.556L300.373+790.541Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.236+735.357L318.106+735.357L318.106+756.371L300.236+756.371L300.236+735.357Z",
    opacity: 1,
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#555555",
    d: "M353.982+734.709L371.851+734.709L371.851+755.723L353.982+755.723L353.982+734.709Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#555555",
    d: "M380.786+734.709L398.656+734.709L398.656+755.723L380.786+755.723L380.786+734.709Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.591+734.709L425.461+734.709L425.461+755.723L407.591+755.723L407.591+734.709Z",
    fill: "#555555",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#555555",
    d: "M452.265+734.709L470.135+734.709L470.135+755.723L452.265+755.723L452.265+734.709Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M479.07+734.709L496.94+734.709L496.94+755.723L479.07+755.723L479.07+734.709Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#555555",
    d: "M511.306+734.709L529.175+734.709L529.175+755.723L511.306+755.723L511.306+734.709Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#555555",
    d: "M555.98+734.709L573.85+734.709L573.85+755.723L555.98+755.723L555.98+734.709Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#555555",
    opacity: 1,
    d: "M582.784+734.709L600.654+734.709L600.654+755.723L582.784+755.723L582.784+734.709Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#555555",
    d: "M327.177+790.541L345.047+790.541L345.047+811.556L327.177+811.556L327.177+790.541Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.982+790.541L371.851+790.541L371.851+811.556L353.982+811.556L353.982+790.541Z",
    opacity: 1,
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#555555",
    d: "M398.656+790.541L416.526+790.541L416.526+811.556L398.656+811.556L398.656+790.541Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M425.461+790.541L443.33+790.541L443.33+811.556L425.461+811.556L425.461+790.541Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#555555",
    opacity: 1,
    d: "M452.265+790.541L470.135+790.541L470.135+811.556L452.265+811.556L452.265+790.541Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.436+790.541L511.306+790.541L511.306+811.556L493.436+811.556L493.436+790.541Z",
    opacity: 1,
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#555555",
    d: "M520.24+790.541L538.11+790.541L538.11+811.556L520.24+811.556L520.24+790.541Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M564.915+790.541L582.784+790.541L582.784+811.556L564.915+811.556L564.915+790.541Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M609.589+790.541L627.459+790.541L627.459+811.556L609.589+811.556L609.589+790.541Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#555555",
    d: "M636.394+790.541L654.263+790.541L654.263+811.556L636.394+811.556L636.394+790.541Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#555555",
    d: "M672.133+790.541L690.003+790.541L690.003+811.556L672.133+811.556L672.133+790.541Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.938+790.541L716.807+790.541L716.807+811.556L698.938+811.556L698.938+790.541Z",
    opacity: 1,
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.177+843.078L345.047+843.078L345.047+864.093L327.177+864.093L327.177+843.078Z",
    opacity: 1,
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#555555",
    d: "M353.982+843.078L371.851+843.078L371.851+864.093L353.982+864.093L353.982+843.078Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#555555",
    opacity: 1,
    d: "M398.656+843.078L416.526+843.078L416.526+864.093L398.656+864.093L398.656+843.078Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.461+843.078L443.33+843.078L443.33+864.093L425.461+864.093L425.461+843.078Z",
    fill: "#555555",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.265+843.078L470.135+843.078L470.135+864.093L452.265+864.093L452.265+843.078Z",
    opacity: 1,
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#555555",
    d: "M493.436+843.078L511.306+843.078L511.306+864.093L493.436+864.093L493.436+843.078Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.935+843.078L538.805+843.078L538.805+864.093L520.935+864.093L520.935+843.078Z",
    fill: "#555555",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.739+843.078L565.609+843.078L565.609+864.093L547.739+864.093L547.739+843.078Z",
    fill: "#555555",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#555555",
    d: "M574.544+843.078L592.414+843.078L592.414+864.093L574.544+864.093L574.544+843.078Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#555555",
    d: "M619.218+843.078L637.088+843.078L637.088+864.093L619.218+864.093L619.218+843.078Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#555555",
    opacity: 1,
    d: "M646.023+843.078L663.893+843.078L663.893+864.093L646.023+864.093L646.023+843.078Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#555555",
    d: "M690.697+843.078L708.567+843.078L708.567+864.093L690.697+864.093L690.697+843.078Z",
    opacity: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/Print.bef3bd362b819453bc1025a2bc4ce0ef.svg";
export { ForwardRef as ReactComponent };